import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { joinClasses } from 'utils/utils';
import { navigateInternally } from 'utils/bolt';
import Store from 'store/store';
import Button from 'components/bolt/button/button';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	onClick(e) {
		let internalLink = e.target.closest('a[href^="#$"]');
		if (internalLink) {
			e.preventDefault();
			let page = internalLink.getAttribute('href').slice(2).trim();
			let navOptions = {};
			if (page.includes('/?')) {
				let [pageId, qs] = page.split('/?');
				page = pageId;
				navOptions.queryString = '?' + qs;
			}
			navigateInternally(page, navOptions);
		}
		const activePage = Store.get().activePage;
		if (internalLink.parentElement.classList.contains('home') && activePage === 'hubScroll') {
			const topElement = document.querySelector('[data-attribute="boltHubPageCarouselHero"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
		if (internalLink.parentElement.classList.contains('about') && activePage === 'aboutUsScroll') {
			const topElement = document.querySelector('[data-section="aboutUsGallery"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
		if (internalLink.parentElement.classList.contains('contact') && activePage === 'contactScroll') {
			const topElement = document.querySelector('[data-section="contact"]');
			if (topElement) {
				topElement.scrollIntoView({ behavior: 'smooth' });
			}
		}
	}

	renderHeaderLogo() {
		const headerLogo = this.props?.appData?.header?.powsterHeader?.logo;
		const headerLogoExclusions = (headerLogo?.pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const headerLogoInclusions = (headerLogo?.pageInclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const isDesktopSize = this.props?.client?.isDesktopSize;
		const activePage = Store.get().activePage;

		let hideHeaderLogo;
		if (headerLogoInclusions.length > 0) {
			hideHeaderLogo = !headerLogoInclusions.includes(activePage);
		} else {
			hideHeaderLogo = headerLogoExclusions.includes(activePage);
		}

		if (headerLogo && isDesktopSize) {
			return (
				<button
				class={joinClasses(s.headerLogo, hideHeaderLogo && s.hide, !headerLogo.path && s.unclickable)}
				onClick={(e) => {
					if (headerLogo.path) {
					const page = headerLogo.path;
					const navOptions = {};
					navigateInternally(page, navOptions);
					}
				}}
				style={{ pointerEvents: !headerLogo.path ? 'none' : 'visible' }}
				key="headerLogo"
				>
				<img src={headerLogo.src} alt={headerLogo.alt} />
				</button>
			);
		}
	}
}